import React from 'react';

function Switch({ value, checked, name, handleChange, id }) {
  return (
    <div className="onoffswitch float-right">
      <input type="checkbox" value={value} checked={checked} name={name} onChange={handleChange} className="onoffswitch-checkbox" id={id} />
      <label className="onoffswitch-label" htmlFor={id}>
        <span className="onoffswitch-inner" />
        <span className="onoffswitch-switch" />
      </label>
    </div>
  );
}

export default Switch;
